module.exports = __webpack_public_path__ + "static/img/goods-50.3c89777.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s28/pop/goods-50.png
// module id = PRo8
// module chunks = 2